import $ from 'jquery';
window.$ = $;

import '@/user/pv_tracking'; // PV計測
import '@/user/cv_tracking'; // CVボタンクリックの計測
import '@/shared/navi'; // サイトナビの表示
import '@/shared/opt-in'; // cookieアラート表示
import '@/shared/timer_popup';
